import {
  ControlledReaptcha,
  ControlledTextfield,
} from "../../components/inputs";
import { Button } from "../../components";
import { InputAdornment } from "@material-ui/core";
import { Person } from "@material-ui/icons";
import React from "react";

const EsqueciSenhaForm = ({
  internal,
  loading,
  captchaRef,
  formProps,
  handleSubmit,
  handleClickBack,
}) => {
  return (
    <form
      className="d-flex flex-column"
      onSubmit={formProps.handleSubmit(handleSubmit)}
    >
      <ControlledTextfield
        label="Usuário"
        name={"user"}
        formProps={formProps}
        margin={"none"}
        uppercase={false}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className={"ml-2 mr-3"}>
              <Person className="color-brand-2" />
            </InputAdornment>
          ),
        }}
      />
      <div className="mini-separator mb-3 mt-3" />
      <div className="row justify-content-center mb-3">
        <ControlledReaptcha
          formProps={formProps}
          name={"token"}
          margin={"none"}
          captchaRef={captchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
        />
      </div>
      <div className="row justify-content-center">
        {!internal && (
          <div className="col-xs-12 col-md-6 mb-2">
            <Button
              className="button-alternative"
              label={"VOLTAR"}
              onClick={handleClickBack}
            />
          </div>
        )}
        <div className="col-xs-12 col-md-6 mb-2">
          <Button loading={loading} label={"ENVIAR"} type={"submit"} />
        </div>
      </div>
    </form>
  );
};

export default EsqueciSenhaForm;
